/**
 * Apples Wetterschlüssel — als Symbol hier, als Wort in der Textdatei.
 *
 * **Zwei Listen mit denselben Schlüsseln, und das ist Absicht.** Die Kachel im
 * Kartenstapel zeigt ein Zeichen, das Blatt dahinter ein Wort; wer einen
 * Schlüssel ergänzt, ergänzt ihn an beiden Stellen. Fehlt eine, fällt der
 * Schlüssel auf sich selbst zurück statt auf eine falsche Sonne.
 *
 * Aufgeführt sind nur die häufigen. Was hier nicht steht, wird als Wort
 * **durchgereicht** und bekommt **kein** Symbol: Apple ergänzt die Liste, ohne
 * zu fragen, und ein erfundenes Zeichen wäre schlimmer als keines — ein
 * unbekannter Schlüssel ist wenigstens als solcher zu erkennen.
 *
 * **Die Wörter stehen seit `0.15.0` in `texte/de.ts`** (`karte.wetterlagen`),
 * die Zuordnung zum Zeichen hier. Derselbe Schnitt wie bei den Nadelfarben:
 * die Mechanik bleibt, wo sie wirkt.
 */
import { WORTLAUT } from '../texte'

/** Die acht Zeichen, die es gibt. `null` heißt: keines, nur die Temperatur. */
export type Lage =
  | 'klar'
  | 'teils'
  | 'wolkig'
  | 'regen'
  | 'schnee'
  | 'gewitter'
  | 'nebel'
  | 'wind'

const SCHLUESSEL: Record<string, Lage> = {
  Clear: 'klar',
  MostlyClear: 'klar',
  PartlyCloudy: 'teils',
  MostlyCloudy: 'wolkig',
  Cloudy: 'wolkig',
  Drizzle: 'regen',
  Rain: 'regen',
  HeavyRain: 'regen',
  Snow: 'schnee',
  Sleet: 'schnee',
  Hail: 'schnee',
  Thunderstorms: 'gewitter',
  Foggy: 'nebel',
  Haze: 'nebel',
  Windy: 'wind',
  Breezy: 'wind',
}

/** Der Schlüssel auf Deutsch — oder er selbst, wenn wir ihn nicht kennen. */
export function beschreibe(code: string): string {
  const worte: Record<string, string> = WORTLAUT.karte.wetterlagen
  return worte[code] ?? code
}

/** Welches Zeichen dazugehört — `null`, wenn wir den Schlüssel nicht kennen. */
export function lageVon(code: string): Lage | null {
  return SCHLUESSEL[code] ?? null
}

/** "aus SW": the eight points of the compass; the letters live in the texts. */
export function himmelsrichtung(grad: number): string {
  const striche: readonly string[] = WORTLAUT.karte.himmelsrichtungen
  return striche[Math.round((((grad % 360) + 360) % 360) / 45) % 8] ?? ''
}
